import React, { useContext, useEffect, useState } from 'react'
import LoginContext from "../Context/Logincontext"
import Nav1 from '../Component/Nav/Nav1'
import { NavLink } from 'react-router-dom'
import "./../styles/AddProduct.css"
import '../styles/AddClient.css'
import Swal from 'sweetalert2'
import { ImExit } from 'react-icons/im'
import CloseButton from '../Component/CloseButton'
import LogoComponent from '../Component/LogoComponent'
import { urlApiServer } from '../Config/Config'

let splitImg = []

const AddInventory = () => {

    const urlPostInventory = urlApiServer + "postinventory";
    const urlgetConfig = urlApiServer + "getConfig";

    const [name, setName] = useState('')
    const [lastNameOne, setLastNameOne] = useState('')
    const [quantity, setQuantity] = useState(null)
    const [typeOfMeasure, setTypeOfMeasure] = useState()
    const [pricePerMeasure, setPricePerMeasure] = useState('')

    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")

    if (lastNameOne === undefined || lastNameOne === '') {
        var fullName = (name !== undefined ? name : '')
    } else {
        var fullName = (name !== undefined ? name : '') + ' ' + (lastNameOne !== undefined ? lastNameOne : '');
    }
    useEffect(() => {
        (async function () {

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetConfig, requesoption).then(response => response.json()).then(quotesResponse => {
                setOldConfig(quotesResponse)
            })
        }())
    }, [])

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);
            }
        }
    }, [oldConfig, infoUser])

    if (logo) {
        splitImg = logo.split("|")
    }

    async function handleName(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        // if (/^[A-Za-z.\s]+$/.test(name) || name === '') {
        setName(name)
        // }
    }

    async function handleQuantity(e) {
        let value = e.target.value
        // e.target.value = value;
        setQuantity(value);
    }

    async function handleTypeOfMeasure(e) {
        let value = e.target.value
        // e.target.value = value;
        setTypeOfMeasure(value);
    }

    async function handlePrecePerMeasure(e) {
        let value = e.target.value
        // e.target.value = value;
        setPricePerMeasure(value);
    }

    async function uploadInventory() {
        // if ((typeDocument === null) || (typeDocument === '')) {
        //     return Swal.fire({
        //         icon: 'warning',
        //         title: '¡Advertencia!',
        //         text: 'Recuerda seleccionar un "Tipo de documento"',
        //         allowOutsideClick: false,
        //     })
        // }

        // if ((position === null) || (position === '')) {
        //     return Swal.fire({
        //         icon: 'warning',
        //         title: '¡Advertencia!',
        //         text: 'Recuerda llenar el campo de "Direccion"',
        //         allowOutsideClick: false,
        //     })
        // }

        const data = JSON.stringify({
            empresa: infoUser.company,
            name: name,
            amount: quantity,
            typeOfMeasure: typeOfMeasure ? typeOfMeasure : 'cantidad',
            pricePerMeasure: pricePerMeasure,
            availability: "Con disponibilidad",
            missingamount: 0
        })
        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
            method: 'POST',
            headers: registerHeaders,
            body: data,
            redirect: 'follow'
        }

        await fetch(urlPostInventory, requesoption).then(response => response.json())
            .then(dataResponse => {
                if (200 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'success',
                        title: '¡Hecho!',
                        text: dataResponse.msj,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = './Inventario';
                        }
                    })
                }
                if (101 === dataResponse.status) {
                    console.log('dataResponse.msj: ', dataResponse.msj)
                    return Swal.fire({
                        icon: 'error',
                        title: '¡Error!',
                        text: dataResponse.msj,
                        confirmButtonText: 'Aceptar',
                    })
                }
            })

    }

    return (
        <>
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    <>
                        <div className="containerHeardANDTable">
                            <div className="HeardANDFilter">
                                <LogoComponent />
                                <div className='containerButtonAdd'>
                                    <div className="navigationContainer">
                                        <div className="pageTitle">CREAR INVENTARIO</div>
                                    </div>
                                </div>
                                <div className='closeIntContainer'>
                                    <CloseButton />
                                </div>
                            </div>
                        </div>
                        <div id='overallContainer' className='overallContainer'>
                            <Nav1 />
                            <div className='drawerFormAddCuotes'>
                                <form className='ContainerClient'>
                                    <div className='containerInfoAdd'>
                                        <div className='infoOneEdit'>
                                            <p className='personalInformationEdit'>AGREGAR INVENTARIO</p>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        value={name}
                                                        name="Name"
                                                        id="Name"
                                                        onChange={handleName}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre del material <em className='Obligatory'>*</em> </label>
                                                </div>

                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        onChange={handleQuantity}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Cantidad disponible<em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">

                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="typeOfMeasure"
                                                        id="typeOfMeasure"
                                                        onChange={handleTypeOfMeasure}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Tipo de medida </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="pricePerMeasure"
                                                        id="pricePerMeasure"
                                                        onChange={handlePrecePerMeasure}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Precio por {typeOfMeasure ? typeOfMeasure : 'cantidad'} <em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className="buttonContainerAddClient">
                                                <NavLink className='Textregister' to="/Inventario"><button className="button neon_Effect"><p>Atras</p></button></NavLink>
                                                <NavLink onClick={uploadInventory} className='Textregister'><button className="button neon_Effect"><p>Agregar</p></button></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : (window.location.href = './Iniciar_Sesión')}
        </>
    )

}

export default AddInventory
